<div [class]="theme" style="height: 100%">
  <sc-navigation *ngIf="session.loginChecked"></sc-navigation>
  <app-session-processing></app-session-processing>
</div>
